/**
 * Belmont free shipping threshold helper.
 *
 * Reads the free shipping threshold assigned to the current visitor by the
 * active Intelligems shipping test group and drives the theme's countdown UIs
 * (header `.shipping_money` bar + Rebuy Smart Cart progress bar) from it.
 * Falls back to $75 (7500 cents) when Intelligems is unavailable or the visitor
 * has no shipping-test assignment.
 */
(function () {
  var DEFAULT_THRESHOLD_CENTS = 7500;

  // Resolve a group's free shipping threshold in cents, or null.
  // Prefers the API field; falls back to parsing the amount from the group name
  // (e.g. "$75 Free Shipping") since Intelligems leaves freeShippingThreshold
  // undefined for name-configured shipping tests.
  function thresholdCentsFromGroup(group) {
    if (!group) return null;
    if (typeof group.freeShippingThreshold === 'number') {
      return Math.round(group.freeShippingThreshold * 100);
    }
    if (typeof group.name === 'string' && /shipping/i.test(group.name)) {
      var match = group.name.match(/\$\s*(\d+(?:\.\d{1,2})?)/);
      if (match) return Math.round(parseFloat(match[1]) * 100);
    }
    return null;
  }

  // Returns the visitor's Intelligems shipping-test threshold in cents, or null
  // when no shipping test is running / assigning them a threshold.
  function getActiveThresholdCents() {
    var user = window.igData && window.igData.user;
    if (!user || typeof user.getExperiments !== 'function') return null;
    try {
      var experiments = user.getExperiments() || [];
      for (var i = 0; i < experiments.length; i++) {
        var cents = thresholdCentsFromGroup(user.getTestGroup(experiments[i].id));
        if (cents !== null) return cents;
      }
    } catch (e) {}
    return null;
  }

  function isShippingTestActive() {
    return getActiveThresholdCents() !== null;
  }

  // Threshold for the theme's own header bar, which always needs a number.
  function getThresholdCents() {
    var active = getActiveThresholdCents();
    return active === null ? DEFAULT_THRESHOLD_CENTS : active;
  }

  // Run `callback` once Intelligems has loaded (or immediately if already ready).
  function onReady(callback) {
    if (window.igData && window.igData.user) {
      callback();
      return;
    }
    window.addEventListener('ig:ready', callback, { once: true });
  }

  // Update the header free shipping bar (`.discount` / `.shipping_money`).
  function updateHeader(subtotalCents) {
    var discounts = document.querySelectorAll('.discount');
    if (!discounts.length) return;
    var remaining = Math.ceil((getThresholdCents() - subtotalCents) / 100);
    discounts.forEach(function (el) {
      if (remaining > 0) {
        el.innerHTML =
          "Spend <span class='shipping_money tw-font-mozaic tw-text-sm var-font-weight-400'>$" +
          remaining +
          '</span> more for FREE Shipping';
      } else {
        el.innerHTML = 'HOORAY! YOUR ORDER SHIPS FREE';
      }
    });
  }

  // Override the Rebuy Smart Cart progress bar so it counts down from the
  // Intelligems threshold instead of Rebuy's static dashboard setting.
  // No-op when no shipping test is running -> leave Rebuy's native bar untouched.
  function updateRebuyProgressBar(subtotalCents) {
    var threshold = getActiveThresholdCents();
    if (threshold === null) return;
    var flyout = document.querySelector('#rebuy-cart .rebuy-cart__flyout');
    if (!flyout) return;
    var remainingCents = threshold - subtotalCents;

    var prompt = flyout.querySelector('.rebuy-cart__progress-bar-prompt');
    if (prompt) {
      if (remainingCents > 0) {
        prompt.innerHTML =
          "You're <span>$" + (remainingCents / 100).toFixed(2) + '</span> from FREE Shipping!';
      } else {
        prompt.innerHTML = 'You unlocked FREE Shipping!';
      }
    }

    var fill = flyout.querySelector('.rebuy-cart__progress-bar-meter-fill');
    if (fill) {
      fill.style.width = Math.max(0, Math.min(100, (subtotalCents / threshold) * 100)) + '%';
    }
  }

  // Pull the current cart once and correct both UIs (server-rendered markup
  // can't know the visitor's Intelligems group).
  function refreshFromCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateHeader(cart.total_price);
        updateRebuyProgressBar(cart.total_price);
      })
      .catch(function () {});
  }

  window.BelmontFreeShipping = {
    getThresholdCents: getThresholdCents,
    getThresholdDollars: function () { return getThresholdCents() / 100; },
    getActiveThresholdCents: getActiveThresholdCents,
    isShippingTestActive: isShippingTestActive,
    onReady: onReady,
    updateHeader: updateHeader,
    updateRebuyProgressBar: updateRebuyProgressBar,
    refreshFromCart: refreshFromCart,
  };

  onReady(refreshFromCart);
})();
